import React, { Component } from 'react'
import serachIcon from './../../icons/searchicon'
import Partneradminlist from './../../component/privatescreening/Partneradminlist'
// Images import
import close from "./../../assets/images/close.svg";
import cloud from "./../../assets/images/cloud.svg";
import plusIcon from "./../../assets/images/plusIcon.svg";
import background from "./../../assets/images/background.jpg";
import Loader from '../../component/loader';
import SimpleReactValidator from 'simple-react-validator';
import service from '../../services'
import AWS from "aws-sdk";
import PopUpCustomAll from '../../component/fpg/create/popUpCustomAll'
import ReactPaginate from 'react-paginate';
import ErrorPopUp from '../../component/errorPopUp';
import commonImage from '../../commonImage';

let sub;
export default class Partneradmin extends Component {
    constructor(props) {
        super(props)

        this.state = {
            imagePreloader: false,
            createOpen: false,
            email: '',
            partnerName: '',
            partnerLogo: '',
            fname: '',
            lname: '',
            partners: [],
            editPartner: {},
            isEdit: false,
            offset: 0,
            perPage: 50,
            currentPage: 0,
            pageCount: 0,
            searchKeyword: '',

            errorPopup: false,
            errorMsg: "",
        }
        this.validator = new SimpleReactValidator({autoForceUpdate: this,
            validators: {
                apostrophe: {  // name the rule
                  message: 'Please use a valid name of the :attribute',
                  rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val,/^([a-zA-Z ' -]*)$/i) && params.indexOf(val) === -1
                  },
                  required: true  // optional
                }
              }});
        this.apiserve = new service();
    }

    componentDidMount = async () => {
        this.getAllPartner(this.state.offset, this.state.perPage);
        this.getEventData();
        this.setState({
            loaderFlag: true
        });
    };
    componentWillUnmount = () => {
        sub.unsubscribe();
    }
    getAllPartner(skip, limit, searchKey) {
        this.setState({ partners: [] })
        var data = {
            page: skip,
            limit: limit
        }
        if (searchKey) data.filter = searchKey;
        this.apiserve.sendevent("privateScreeningPartner|getAll", data);
    }


    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true
            },
            () => {
                this.getAllPartner(offset, this.state.perPage, this.state.searchKeyword);
            }
        );
    };


    getEventData = () => {
        var self = this
        sub = this.apiserve.getevent().subscribe(response => {
            switch (response.event) {
                case "privateScreeningPartner|create":
                    if (!response.error) {
                        this.apiserve.success("Partner added successful.")
                        this.clearFn();
                        this.getAllPartner(self.state.offset, self.state.perPage);
                        this.setState({ createOpen: false });
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "privateScreeningPartner|getAll":
                    if (response.error === true) {
                        this.setState({
                            loaderFlag: false,
                            errorMsg: true,
                            errorMsgShow: response.data.error
                        });
                    } else {
                        this.setState({ loaderFlag: false, partners: (response.data && response.data.docs) || [], pageCount: Math.ceil(response.data.totalDocs / self.state.perPage), })
                    }
                    break;
                case 'privateScreeningPartner|edit':
                    if (!response.error) {
                        this.apiserve.success("Partner Update successful.")
                        this.clearFn();
                        this.getAllPartner(self.state.offset, self.state.perPage);
                        this.setState({ createOpen: false });
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case 'privateScreeningPartner|blockPrivateScreeningPartner':
                    if (!response.error) {
                        this.apiserve.success("Partner Update successful.")
                        this.getAllPartner(self.state.offset, self.state.perPage);
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case 'privateScreeningPartner|remove':
                    if (!response.error) {
                        this.clearFn();
                        this.apiserve.success("Partner Deleted successful.")
                        this.getAllPartner(self.state.offset, self.state.perPage);
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
            }
        });
        this.forceUpdate();
    };

    CreatePartner = () => {
        this.setState({
            createOpen: true
        })
    }

    closePartnerUser = () => {
        this.setState({
            createOpen: false
        })
        this.clearFn();
    }
    clearFn = () => {
        this.validator.hideMessages();
        this.setState({
            imagePreloader: false,
            email: '',
            partnerName: '',
            partnerLogo: '',
            fname: '',
            lname: '',
            isEdit: false,
            deleteFilm: '',
            searchKeyword: ''
        })
    }
    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
        var self = e.target.value;
        if (e.target.name === 'searchKeyword' && e.target && e.target.value.length > 0) {
            setTimeout(() => {
                this.getAllPartner(0, this.state.perPage, this.state.searchKeyword || self);
            }, 200);
        }
        else if (e.target.name === 'searchKeyword' && e.target && e.target.value.length === 0) {
            this.setState({ searchKeyword: '' })
            setTimeout(() => {
                this.getAllPartner(0, this.state.perPage);
            }, 200);
        }
        this.forceUpdate();
    };

    onEditPartner = (item) => {
        if (item) {
            this.setState({
                editPartner: item,
                isEdit: true,
                createOpen: true,
                email: item.email,
                partnerName: item.partnerName,
                partnerLogo: item.partnerLogo || '',
                fname: item.fname,
                lname: item.lname
            }, () => { this.forceUpdate() })
        }
    }

    validate = () => {
        let emailErr = '';
        let pName = '';
        let lnameErr = '';
        let fnameErr = '';
        if (!this.state.email) {
            emailErr = 'This field is required.'
        } else {
            if (!this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                emailErr = 'Email address must be valid email.';
            }
            if (!this.state.partnerName) {
                pName = 'This field is required.'
            }
            if (!this.state.fname) {
                fnameErr = 'This field is required.'
            }
            if (!this.state.lname) {
                lnameErr = 'This field is required.'
            }

            this.setState({ emailErr, pName, lnameErr, fnameErr });
            if (emailErr || pName || fnameErr || lnameErr) {
                return false
            }
            return true
        }
    }

    submitFn = (e) => {
        e.preventDefault();
        const { email, partnerName, partnerLogo, fname, lname, isEdit, editPartner } = this.state
        const isValid = this.validate()
        if (isValid) {
            var data = {
                email: email,
                partnerName: partnerName,
                fname: fname,
                lname: lname,
            }
            if (partnerLogo !== "") {
                data.partnerLogo = partnerLogo;
            }

            if (isEdit && editPartner) {
                data.id = editPartner._id
                this.apiserve.sendevent("privateScreeningPartner|edit", data);
            } else {
                this.apiserve.sendevent("privateScreeningPartner|create", data);
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
        this.forceUpdate();
    }

    onChangeFile(e) {
        this.setState({ imagePreloader: true })
        if(e.target.files[0]){
            let file = e.target.files[0];
            if((file && file.type === "image/png") ||
            (file && file.type === "image/jpg") ||
            (file && file.type === "image/jpeg")){

                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB',
                        imagePreloader:false
                    })
                    return false;
                }else{
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onloadend = (event) => {
                        setTimeout(() => {
                            this.imageUploadPanel(file,event.target.result);
                        }, 0);
                    };
                }
            }
            else{
                this.setState({
                    errorPopup: true,
                    errorMsg: "Please upload .PNG, JPG or .JPEG file only",
                    imagePreloader:false
                });
            }
           
        }
    }

    imageUploadPanel = (file, img) => {
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
            this.setState({ partnerLogo: value, imagePreloader: false })
        });
    };

    blockPartner = (item) => {
        if (item) {
            var data = {
                userId: item._id,
                role: "privateScreeningPartner",
                isBlocked: !item.isBlocked
            }
            this.apiserve.sendevent("privateScreeningPartner|blockPrivateScreeningPartner", data);
        }
    }
    deletePartner = (item) => {
        if (item) {
            this.setState({ deleteFilm: item })

        }
    }

    deleteFilmPopupYes = () => {
        if (this.state.deleteFilm) {
            var data = {
                id: this.state.deleteFilm._id
            }
            this.apiserve.sendevent("privateScreeningPartner|remove", data);
        }

    }

    render() {
        return (
            <>
                <div className="right_side_wrapper adminDashboard_wrapper">
                    <div className="dashboard_header with_btn privateScreening_header">
                        <div className="searchBlock">
                            <span>Partners ({this.state.partners.length || 0})</span>
                            <form>
                                <input type="text" placeholder="Search" name='searchKeyword' value={this.state.searchKeyword} onChange={this.onInputChange} />
                                <button type="button" >
                                    <img src={serachIcon} />
                                </button>
                            </form>
                        </div>
                        <div className="button_block admin_user_twoBtn">
                            <span></span>
                            <span className="head_btn pointer" onClick={this.CreatePartner}> Create Partner + </span>
                        </div>
                    </div>
                    <div className="dashboard_data partner_tbl">
                        {
                            this.state.partners && this.state.partners.length > 0 && this.state.pageCount > 0
                                ? <Partneradminlist partners={this.state.partners} history={this.props.history} onEditPartner={this.onEditPartner} blockPartner={this.blockPartner} deletePartner={this.deletePartner} /> : ''
                        }
                        {this.state.partners && this.state.pageCount > 0 ? (
                            <div className="custom-pagination">
                                <ReactPaginate
                                    previousLabel={""}
                                    nextLabel={""}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={this.state.currentPage}
                                />
                            </div>
                        ) : (
                                ""
                            )}

                    </div>



                    {this.state.deleteFilm ? (
                        <PopUpCustomAll
                            HeaderName="Delete?"
                            insideDetails="You are about to delete an item and this action is permanent"
                            insideData="Do you want to proceed?"
                            popupState={this.clearFn}
                            yesPopUp={this.deleteFilmPopupYes}
                        />
                    ) : (
                            ""
                        )}
                </div>
                {this.state.createOpen ?

                    <div className="popup_wrapper partner-event-popup">
                        <h2>
                            {this.state.isEdit ? 'Edit Partner Details' : 'Create New Partner'}
                            <img src={close} onClick={() => this.closePartnerUser()} />
                        </h2>
                        <form onSubmit={(e) => this.submitFn(e)}>
                            <div className="details">
                                <div className="partnerLogo d_flex_justify_unset">
                                    <label>Partner Logo<span>(optional)</span></label>
                                    <div className='image_pre_loader'>
                                        <input id="myInput"
                                            type="file"
                                            ref={(ref) => this.upload = ref}
                                            style={{ display: 'none' }}
                                            onChange={this.onChangeFile.bind(this)}
                                            accept=".png, .jpg, .jpeg"
                                            tabIndex='1'
                                        />
                                        {this.state.imagePreloader ?
                                            <Loader />
                                            :
                                            <img src={this.state.partnerLogo ?
                                                this.apiserve.imageUrl + this.state.partnerLogo :
                                                background
                                            } />
                                        }
                                        <a onClick={() => { this.upload.click() }}><img src={plusIcon} /></a>
                                    </div>
                                </div>
                                <div className="form_group">
                                    <label>Partner Name</label>
                                    <div className="form_group_input">
                                        <input
                                            type="text"
                                            name="partnerName"
                                            id="partnerName"
                                            value={this.state.partnerName}
                                            onChange={this.onInputChange}
                                            tabIndex='2'
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('partner name', this.state.partnerName, 'required|apostrophe')}</span>
                                    </div>
                                </div>
                                <div className="form_group">
                                    <label>Partner Email</label>
                                    <div className="form_group_input">
                                        <input
                                            type="email"
                                            name="email"
                                            id="email"
                                            disabled={this.state.changeTitleName ? true : false}
                                            maxLength={255}
                                            value={this.state.email}
                                            onChange={this.onInputChange}
                                            tabIndex='3'
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('email', this.state.email, 'required|email')}</span>
                                    </div>
                                </div>
                                <div className="form_group">
                                    <label>First Name</label>
                                    <div className="form_group_input">
                                        <input
                                            type="text"
                                            name="fname"
                                            id="fname"
                                            maxLength={100}
                                            value={this.state.fname}
                                            onChange={this.onInputChange}
                                            tabIndex='4'
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('firstname', this.state.fname, 'required|apostrophe')}</span>
                                    </div>
                                </div>
                                <div className="form_group">
                                    <label>Last Name</label>
                                    <div className="form_group_input">
                                        <input
                                            type="text"
                                            name="lname"
                                            id="lname"
                                            maxLength={100}
                                            value={this.state.lname}
                                            onChange={this.onInputChange}
                                            tabIndex='5'
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('lastname', this.state.lname, 'required|apostrophe')}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="btn_wrapper">
                                <button className="grayBTN"
                                    type="button"
                                    onClick={() => this.clearFn()}
                                    tabIndex='7'
                                >Clear</button>
                                <button className="orangeBTN"
                                    type="submit"
                                    disabled={this.state.imagePreloader ? true : false}
                                    onClick={(e) => this.submitFn(e)}
                                    tabIndex='6'
                                >Submit</button>
                            </div>
                        </form>
                    </div>
                    :
                    ""
                }

                        {this.state.errorPopup ?
                            <ErrorPopUp
                                errorMsg={this.state.errorMsg}
                                errorMsgPopup={()=>this.setState({
                                    errorPopup: false,
                                    errorMsg:''
                                })}
                            />
                            : ''
                        }
                        </>
        )
    }
}
